const SoftwareList = () => import('Views/software/software-list-new-ui');
const SoftwareDetail = () => import('Views/software/software-detail-new-ui');
const SoftwareFaq = () => import('Views/software/software-faq-new-ui');

export default[
  { path: '/software-list', component: SoftwareList },
  { path: '/software-detail/:id', component: SoftwareDetail },
  { path: '/software-faq/:id', component: SoftwareFaq },
];



// WEBPACK FOOTER //
// ./src/router/software.js